var exports = {
  "K": "EditFavoriteMemeModal.module__formContainer___MFJ5OX",
};

module.exports = exports;
